import type { IBetLog, ITransaction } from '@hit-game/shared/types';

import { http, type Paginated } from '../lib/http';

export const betLogService = {
  /** Lịch sử cược ĐÃ đồng bộ về DB — muốn dữ liệu mới thì gọi `accountService.syncBetLogs` trước. */
  list(accountId: string, params?: { page?: number; limit?: number }): Promise<Paginated<IBetLog>> {
    return http.get(`/betlogs/${accountId}`, { params, _silent: true });
  },
};

export const transactionService = {
  list(
    accountId: string,
    params?: { page?: number; limit?: number; slipType?: number },
  ): Promise<Paginated<ITransaction>> {
    return http.get(`/transactions/${accountId}`, { params, _silent: true });
  },
};
